import React, { useState, useRef, useEffect } from "react";
import './Pin.scss'
import { encrypt } from "../../../../../Shared/helper/helper";
import { useLanguage } from "../../../../../Shared/cache/context/LanguageProvider";
import useFetch from "../../../../../Shared/cache/useFetch";
import { GET, ORP_TRANSLATION, TRANSLATION } from "../../../../../Shared/helper/constants";

const PinComponent = ({ amount, sendEncryptedPin, showIncorrectPinMessage, noOfAttemptsLeftForPIN, showPinLockedMessage,
    customerCareNumber,dial,toggleModalEvent,walletMessages
}) => {
    const [value, setValue] = useState(new Array(4).fill(""));
    const inputRefs = useRef([]);
    const [showModal, setShowModal] = useState(true);
    const [translation, setTranslation] = useState({
        moneyDeductMessage: "Will be deducted from your Account.",
        incorrectPinMesage: "Please enter correct PIN",
        attemptsLeft: "ATTEMPTS LEFT",
        walletLocked: "Wallet Locked?",
        unlockSteps: "To unlock kindly visit nearby Airtel shop or call customer care",
        forgetPin: "Forgot your PIN?",
        reset:"To RESET it, dial",
        resetSteps: ", select my account, then MY PIN and Reset PIN/Forgot PIN.",
    });
    const { languagePrefix,selectedLanguage } = useLanguage();
    const { data,refetch } = useFetch({
        url: ORP_TRANSLATION.replace('languagePrefix', languagePrefix),
        method: GET,
        key: TRANSLATION,
        cache: {
            enabled: true,
            ttl: 3600
        }
    });

    useEffect(() => {
        if (data?.payment?.amPin) setTranslation(data?.payment?.amPin)
    }, [data])

    useEffect(() => {
        const cachedData = sessionStorage.getItem(`${TRANSLATION}_${selectedLanguage}`);
        if (!cachedData) {
            refetch(true);
        }else {
          refetch(false)
        }
    }, [selectedLanguage]);

    const handleChange = (element, index) => {
        const inputValue = element.value;
        if (/^\d$/.test(inputValue) || inputValue === "") {
            const newValue = [...value];
            newValue[index] = inputValue;
            setValue(newValue);

            if (inputValue !== "" && index < 3) {
                inputRefs.current[index + 1].focus();
            }

            if (index === 3 && inputValue) {
                generateEnteredValue(newValue);
                // verifyOtp(newValue);

            }
        }
    };

    const generateEnteredValue = (value) => {
        let pin = Object.values(value).join("")
        encryptData(pin)
    }

    const encryptData = (pin) => {
    //    let encryptedData = encrypt(pin);
        sendEncryptedPin(pin)
    };

    const handleBackspace = (e, index) => {
        if (e.key === "Backspace" && index > 0 && value[index] === "") {
            inputRefs.current[index - 1].focus();
        }
    };

    const closeAmPinModal = () => {
        setTimeout(() => toggleModalEvent(), 1000);
        setShowModal(false);
    }



    return (<>
        {showModal && <div id="myModal" className="airtelmoneyPin otp_verification-outer adv-modal modal fade in" role="dialog"
        >
            <div className="otp-modal otp_verification_modal">
                <div className="otp-header">
                    <a className="close" onClick={closeAmPinModal} >X</a>
                    <h4>{walletMessages?.enterPin}</h4>
                    <h5> {process.env.REACT_APP_CURRENCY} <span> {amount}</span> {translation?.moneyDeductMessage}</h5>
                </div>

                <div className="modal-body">
                    <div className="otp_box">
                        <div className="otp_bx_wrap">
                            {value?.map((data, index) => (
                                <input
                                    className={`${(showIncorrectPinMessage || showPinLockedMessage) ? 'otp-error' : ''}`}
                                    key={index}
                                    type="password"
                                    maxLength="1"
                                    autocomplete="off"
                                    value={value[index]}
                                    onChange={(e) => handleChange(e.target, index)}
                                    onKeyDown={(e) => handleBackspace(e, index)}
                                    ref={(el) => (inputRefs.current[index] = el)}

                                />
                            ))}
                        </div>
                        {showIncorrectPinMessage && <div className="otp-errorMsg">
                            <span>
                                {translation?.incorrectPinMesage}
                            </span>
                            <span> {noOfAttemptsLeftForPIN}{' '}{translation?.attemptsLeft} </span>

                        </div>}
                    </div>
                    {showPinLockedMessage && <div className="wallet-errorwrap">
                        <div className="wallet-error">
                            <img src="assets/icons/alert.svg" />
                            {walletMessages?.walletBlockedMessage}
                        </div>
                        <p><strong>{translation?.walletLocked}</strong>{translation?.unlockSteps}{' '}{customerCareNumber}</p></div>
                    }
                    {!showPinLockedMessage && <p><strong>{translation?.forgetPin}</strong> {translation?.reset}{' '}<a href={`tel:${dial}`}>{dial}</a>{translation?.resetSteps}</p>}
                </div>
            </div>

        </div>}
    </>)
}

export default PinComponent